module.exports = __webpack_public_path__ + "static/img/menage9.26319c18.jpg";